import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const MinuteWhiteBg = (props: Props): JSX.Element => {
    return <S_MinuteWhiteBg className={props.className} />;
};

const S_MinuteWhiteBg = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    background: url('https://dvtqxks0zalev.cloudfront.net/app-static/company-city.png');
    background-size: cover;
    opacity: 0.6;
`;
